{
  "version": 1,
  "asset_id": "eaf29150-54fc-44e4-8c1c-243bb62f1d34",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/eaf29150-54fc-44e4-8c1c-243bb62f1d34/clip-img_0047.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/eaf29150-54fc-44e4-8c1c-243bb62f1d34/clip-img_0047.mp4",
  "original_filename": "clip-img_0047.mp4",
  "size": 149304,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:30Z"
}
